module.exports = __webpack_public_path__ + "static/media/1 28 utviklingsmuligheter.935bb970.mp3";